import './EpisodesList.scss'
import icon_play from "../../Pages/Player/images/play.png";
import { useRouter } from "../../../hooks/router";
import { translateWord } from '../../Util/util';

export default function CardEpisodes({ elem, play_episode_info_field }) {
    const router = useRouter()
    return (
        <div className={"card_episode"} onClick={() => play_episode_info_field(elem)}>
            <div className="image_episode">
                <img src={elem.poster} className={'image_bg'} alt="" />
                <div className="icon_play_episode">
                    <img src={icon_play} alt="" />
                </div>
            </div>

            <div className="description_episode">
                <span className="episode_num">Episode {elem.number}</span>
                <span className="episode_name">{elem.episode_translation ? (elem.episode_translation.name || elem.name) : elem.name}</span>
                <div className="progress_episode" style={router.query.type ? { width: '94%' } : null}>
                    <div className="progress_bar_episode" style={{ width: `${elem.watched ? elem.watched.percent : 0}%` }}></div>
                </div>
                <span className="duration_episode">{elem.duration ? Math.round(elem.duration / 60) + " " + translateWord('min') : ''} </span>
            </div>
        </div>
    )
}